export const hashedCustomersMapperMongoColumns = [
  {
    label: 'Customer Email',
    is_array: false,
    options: [
      {
        label: 'SHA 2 Hashed email',
        value: 'email_sha_2_hash',
      },
    ],
  },
]

export const optOutCustomersMapperMongoColumns = [
  {
    label: 'Customer Email',
    is_array: false,
    options: [
      {
        label: 'SHA 2 Hashed email',
        value: 'email_sha_2_hash',
      },
      {
        label: 'Email',
        value: 'email',
      },
    ],
  },
]

export const customersMapperMongoColumns = [
  {
    label: 'Customer details',
    options: [
      {
        label: 'First Name',
        value: 'first_name',
      },
      {
        label: 'Middle Name',
        value: 'middle_name',
      },
      {
        label: 'Last Name',
        value: 'last_name',
      },
      {
        label: 'Birth Date',
        value: 'birth_date',
      },
    ],
  },
  {
    label: 'Customer Email',
    is_array: false,
    options: [
      {
        label: 'Primary email',
        value: 'email',
      },
      {
        label: 'Secondary email',
        value: 'alt_email',
      },
      {
        label: 'SHA-256 email',
        value: 'email_sha_2_hash',
      },
    ],
  },
  {
    label: 'Customer Phone',
    is_array: false,
    options: [
      {
        label: 'Mobile phone',
        value: 'phone',
      },
      {
        label: 'Home phone',
        value: 'home_phone',
      },
      {
        label: 'Work phone',
        value: 'work_phone',
      },
    ],
  },
  {
    label: 'Customer Address',
    // TODO - discuss with alex about this
    is_array: false,
    options: [
      {
        label: 'Address',
        value: 'address',
      },
      {
        label: 'Address 2',
        value: 'address2',
      },
      {
        label: 'City',
        value: 'city',
      },
      {
        label: 'State',
        value: 'state',
      },
      {
        label: 'Country',
        value: 'country',
      },
      {
        label: 'Zip',
        value: 'zip',
      },
    ],
  },
  {
    label: 'Co-Buyer details',
    options: [
      {
        label: 'Co-Buyer First Name',
        value: 'co_buyer_first_name',
      },
      {
        label: 'Co-Buyer Middle Name',
        value: 'co_buyer_middle_name',
      },
      {
        label: 'Co-Buyer Last Name',
        value: 'co_buyer_last_name',
      },
      {
        label: 'Co-Buyer Birth Date',
        value: 'co_buyer_birth_date',
      },
    ],
  },
  {
    label: 'Co-Buyer Email',
    is_array: false,
    options: [
      {
        label: 'Co-Buyer Primary email',
        value: 'co_buyer_email',
      },
      {
        label: 'Co-Buyer Secondary email',
        value: 'co_buyer_alt_email',
      },
    ],
  },
  {
    label: 'Co-Buyer Phone',
    is_array: false,
    options: [
      {
        label: 'Co-Buyer Mobile phone',
        value: 'co_buyer_phone',
      },
      {
        label: 'Co-Buyer Home phone',
        value: 'co_buyer_home_phone',
      },
      {
        label: 'Co-Buyer Work phone',
        value: 'co_buyer_work_phone',
      },
    ],
  },
  {
    label: 'Co-Buyer Address',
    // TODO - discuss with alex about this
    is_array: false,
    options: [
      {
        label: 'Co-Buyer Address',
        value: 'co_buyer_address',
      },
      {
        label: 'Co-Buyer Address 2',
        value: 'co_buyer_address2',
      },
      {
        label: 'Co-Buyer City',
        value: 'co_buyer_city',
      },
      {
        label: 'Co-Buyer State',
        value: 'co_buyer_state',
      },
      {
        label: 'Co-Buyer Country',
        value: 'co_buyer_country',
      },
      {
        label: 'Co-Buyer Zip',
        value: 'co_buyer_zip',
      },
    ],
  },
  {
    label: 'Vehicle',
    // TODO - discuss with alex about this
    is_array: false,
    options: [
      {
        label: 'VIN',
        value: 'vin',
      },
      {
        label: 'Make',
        value: 'make',
      },
      {
        label: 'Model',
        value: 'model',
      },
      {
        label: 'Year',
        value: 'year',
      },
      {
        label: 'Trim',
        value: 'trim',
      },
      {
        label: 'Mileage',
        value: 'mileage',
      },
      {
        label: 'Int. Color',
        value: 'int_color',
      },
      {
        label: 'Ext. Color',
        value: 'ext_color',
      },
      {
        label: 'Stock #',
        value: 'stock_number',
      },
      {
        label: 'Status',
        value: 'status',
      },
      {
        label: 'Transmission',
        value: 'transmission',
      },
      {
        label: 'Price',
        value: 'price',
      },
    ],
  },
  {
    label: 'Business details',
    options: [
      {
        label: 'Business Name',
        value: 'business_name',
      },
    ],
  },
  {
    label: 'Leads',
    options: [
      {
        label: 'Lead Date',
        value: 'lead_date',
      },
      {
        label: 'Lead Source',
        value: 'lead_source',
      },
    ],
  },
  {
    label: 'Sales',
    options: [
      {
        label: 'Sale Date',
        value: 'sale_date',
      },
      {
        label: 'Sale Cost',
        value: 'sale_cost',
      },
    ],
  },
  {
    label: 'Service',
    options: [
      { label: 'Service Date', value: 'service_date' },
      { label: 'Service Cost', value: 'service_cost' },
    ],
  },
]
